export default "__VITE_ASSET__CRHB6fwB__"